import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  ApiErrorMessageOptions,
  ApiErrorMessageService,
} from './api-error-message.service';

@Pipe({ name: 'apiErrorMessage' })
export class ApiErrorMessagePipe implements PipeTransform {
  private readonly messages = inject(ApiErrorMessageService);

  transform(error: unknown, options?: ApiErrorMessageOptions): string {
    return this.messages.messageFor(error, options);
  }
}
